/**
 * Limpieza automática de errores de codificación (mojibake y caracteres C1) en descripciones de producto.
 * Convierte caracteres corruptos:
 *  - U+0090 -> é (ej. Pok\u0090mon -> Pokémon)
 *  - U+0091 -> ñ (ej. dise\u0091o -> diseño, a\u0091os -> años)
 *  - U+0092 -> í (ej. l\u0092nea -> línea, estanter\u0092as -> estanterías, S\u0092 -> Sí)
 *  - U+0093 -> ó (ej. ic\u0093nico -> icónico, opci\u0093n -> opción, colecci\u0093n -> colección)
 *  - U+0094 -> ú
 *  - Y variantes con comillas tipográficas mojibake (‘, ’, “) y espacios faltantes.
 */
(function () {
  'use strict';

  var replacements = [
    // 1. Caracteres de control C1 (Windows-1252 a UTF-8 mal importados)
    [/\u0090/g, 'é'],
    [/\u0091/g, 'ñ'],
    [/\u0092/g, 'í'],
    [/\u0093/g, 'ó'],
    [/\u0094/g, 'ú'],

    // 2. Errores comunes de texto
    [/\bPok\s*mon\b/gi, 'Pokémon'],
    [
      /\baut\s+ntic([ao]s?)\b/gi,
      function (match, suffix) {
        var prefix = match[0] === match[0].toUpperCase() ? 'Auténtic' : 'auténtic';
        return prefix + suffix;
      }
    ],
    [
      /\br\s+pid([ao]s?)\b/gi,
      function (match, suffix) {
        var prefix = match[0] === match[0].toUpperCase() ? 'Rápid' : 'rápid';
        return prefix + suffix;
      }
    ],
    [
      /\bf\s+cil(es)?\b/gi,
      function (match, suffix) {
        var prefix = match[0] === match[0].toUpperCase() ? 'Fácil' : 'fácil';
        return prefix + (suffix || '');
      }
    ],
    [
      /\bpr\s+ctic([ao]s?)\b/gi,
      function (match, suffix) {
        var prefix = match[0] === match[0].toUpperCase() ? 'Práctic' : 'práctic';
        return prefix + suffix;
      }
    ],
    [
      /\bAseg[’']r([a-z]+)\b/gi,
      function (match, suffix) {
        var prefix = match[0] === match[0].toUpperCase() ? 'Asegúr' : 'asegúr';
        return prefix + suffix;
      }
    ],
    [
      /\bic[“"']nic([ao]s?)\b/gi,
      function (match, suffix) {
        var prefix = match[0] === match[0].toUpperCase() ? 'Icónic' : 'icónic';
        return prefix + suffix;
      }
    ],

    // 3. Comillas en palabras como sustituto de tildes o ñ
    [/([a-zA-ZáéíóúÁÉÍÓÚ])[“"']n\b/g, '$1ón'],
    [/([a-zA-ZáéíóúÁÉÍÓÚ])‘([aeiou])/gi, '$1ñ$2'],
    [/([a-zA-ZáéíóúÁÉÍÓÚ])’([a-zA-ZáéíóúÁÉÍÓÚ])/g, '$1í$2'],
    [/\bS[’']\b/g, 'Sí'],
    [/\bs[’']\b/g, 'sí']
  ];

  function cleanNodeText(root) {
    if (!root) return;
    try {
      var walker = document.createTreeWalker(
        root,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode: function (node) {
            if (!node || !node.nodeValue) return NodeFilter.FILTER_REJECT;
            var parent = node.parentElement;
            if (parent && (parent.tagName === 'SCRIPT' || parent.tagName === 'STYLE')) {
              return NodeFilter.FILTER_REJECT;
            }
            return NodeFilter.FILTER_ACCEPT;
          }
        },
        false
      );

      var nodes = [];
      var curr;
      while ((curr = walker.nextNode())) {
        nodes.push(curr);
      }

      for (var i = 0; i < nodes.length; i++) {
        var textNode = nodes[i];
        var text = textNode.nodeValue;
        if (!text) continue;

        var modified = false;
        for (var j = 0; j < replacements.length; j++) {
          var regex = replacements[j][0];
          var replacer = replacements[j][1];
          if (regex.test(text)) {
            text = text.replace(regex, replacer);
            modified = true;
          }
        }

        if (modified) {
          textNode.nodeValue = text;
        }
      }
    } catch (e) {
      // Fallback silencioso
    }
  }

  function runClean() {
    var selectors = [
      '.product__description',
      '.product-description',
      '.custom__tab-content',
      '.accordion__content',
      '.product-card__description',
      '[data-product-description]'
    ];
    var elements = document.querySelectorAll(selectors.join(','));
    for (var i = 0; i < elements.length; i++) {
      cleanNodeText(elements[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runClean);
  } else {
    runClean();
  }

  window.addEventListener('load', runClean);
  document.addEventListener('click', function (e) {
    if (e.target && (e.target.closest('summary') || e.target.closest('.custom__tab') || e.target.closest('.accordion'))) {
      setTimeout(runClean, 50);
    }
  });
})();
